// extracted by mini-css-extract-plugin
module.exports = {"followBtn":"styles_followBtn__3KCeL","following":"styles_following__B-oe7"};